import { useEffect } from 'react';
import http from 'lc-http';
import styles from '../styles/main.module.scss';
import errorStyles from '../styles/errorPage.module.scss';

export default function Custom500() {
  useEffect(() => {
    const body = {
      msg: 'LC-WEBSITE: is down & maintenance page is up',
      url: window.location.href,
    };
    http.post('/api/clientToServerLogging', body);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const currentYear = new Date().getFullYear();
  return (
    <main className={styles.main}>
      <div className={styles.landingPage}>
        <div className={styles.components}>
          <div className={errorStyles.header}>
            <div className={errorStyles.logo} />
            <p className={errorStyles.title}>
              Our site is offline for maintenance right now. We’ll be back soon.
            </p>
          </div>
          <div className={errorStyles.footer}>
            <p>
              Questions?{' '}
              <a href="mailto:support@lendingclub.com" className={styles.link}>
                Contact us
              </a>
              .
            </p>
            <p>
              Investors can reach us at{' '}
              <a
                href="mailto:investing@lendingclub.com"
                className={styles.link}
              >
                Investor Services
              </a>
              .
            </p>
            <p className={errorStyles.copyright}>
              © Copyright 2006-{currentYear}. All rights reserved
              <br />
              Lending Club 595 Market Street, Suite 200 San Francisco, CA 94105
              USA
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}
